module.exports = __webpack_public_path__ + "img/2.b4dc3188.jpg";